<template>
  <quran-program v-if="quranProgram == 1"></quran-program>
  <user v-else-if="['student', 'teacher'].includes($role)" />
  <admin v-else />
</template>

<script>
// v-if="user.account_type != 'admin' && !master"
import User from "./User.vue";
import Admin from "./Admin.vue";
import QuranProgram from "./QuranProgram.vue";

import Auth from "@/Apis/Auth";
export default {
  components: {
    User,
    Admin,
    QuranProgram,
  },
  data() {
    return {
      user: Auth.USER,
      quranProgram: 0,
    };
  },
  created() {
    const quran = localStorage.getItem("quran");
    if (quran == 1) {
      this.quranProgram = 1;
      if (Auth.USER.account_type == "student") {
        Auth.MENU_ITEMS = quranProgramStudent;
      } else {
        Auth.MENU_ITEMS = quranProgramTeacher;
      }
    }
  },
};
</script>

<style>
</style>